import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { allTypesUrl } from "@temp/app/routes";
import React from "react";
import { useIntl } from "react-intl";
import { NavLink as RRNavLink } from "react-router-dom";
import NoPhoto from "../../images/no-photo.svg";
import NavItem from "./NavItem";
export function Categories(_ref) {
  var hideOverlayHandler = _ref.hideOverlayHandler,
      allTypesImage = _ref.allTypesImage,
      children = _ref.children;
  var intl = useIntl();
  return React.createElement(React.Fragment, null, React.createElement("ul", {
    className: "categories"
  }, React.createElement("li", {
    className: "nav-item"
  }, React.createElement(RRNavLink, {
    to: allTypesUrl,
    onClick: function onClick() {
      window.scrollTo({
        behavior: "smooth",
        top: 100
      });
      hideOverlayHandler();
    }
  }, (allTypesImage === null || allTypesImage === void 0 ? void 0 : allTypesImage.url) && React.createElement("div", {
    className: "nav-item__image",
    style: {
      backgroundImage: "url(".concat(allTypesImage.url || NoPhoto, ")")
    }
  }, React.createElement("div", {
    className: "nav-item__image-overlay"
  })), React.createElement("span", {
    className: "nav-item__title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "all types",
    "id": "components.MainMenu.Categories.156713073"
  }, "id", "components.MainMenu.Categories.156713073"))))), children === null || children === void 0 ? void 0 : children.map(function (subItem, i) {
    var _subItem$category, _subItem$category$bac;

    return subItem && React.createElement(NavItem, _extends({
      key: i,
      hideOverlay: hideOverlayHandler,
      imageUrl: ((_subItem$category = subItem.category) === null || _subItem$category === void 0 ? void 0 : (_subItem$category$bac = _subItem$category.backgroundImage) === null || _subItem$category$bac === void 0 ? void 0 : _subItem$category$bac.url) || NoPhoto
    }, subItem));
  })), React.createElement("div", {
    className: "categories-scrolled-wrapper"
  }, React.createElement("ul", {
    className: "categories categories-scrolled"
  }, React.createElement("li", {
    className: "nav-item"
  }, React.createElement(RRNavLink, {
    to: allTypesUrl,
    onClick: hideOverlayHandler
  }, (allTypesImage === null || allTypesImage === void 0 ? void 0 : allTypesImage.url) && React.createElement("div", {
    className: "nav-item__image",
    style: {
      backgroundImage: "url(".concat(allTypesImage.url || NoPhoto, ")")
    }
  }, React.createElement("div", {
    className: "nav-item__image-overlay"
  }), React.createElement("span", {
    className: "nav-item__title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "all types",
    "id": "components.MainMenu.Categories.156713073"
  }, "id", "components.MainMenu.Categories.156713073")))))), children === null || children === void 0 ? void 0 : children.map(function (subItem, i) {
    var _subItem$category2, _subItem$category2$ba;

    return subItem && React.createElement(NavItem, _extends({
      key: i,
      hideOverlay: hideOverlayHandler,
      imageUrl: ((_subItem$category2 = subItem.category) === null || _subItem$category2 === void 0 ? void 0 : (_subItem$category2$ba = _subItem$category2.backgroundImage) === null || _subItem$category2$ba === void 0 ? void 0 : _subItem$category2$ba.url) || NoPhoto,
      isScrolled: true
    }, subItem));
  }))));
}